import { createTRPCReact, type CreateTRPCReact } from "@trpc/react-query";
import { httpBatchLink } from "@trpc/client";
import type { AppRouter } from "@bookclubapp/shared";

export const trpc: CreateTRPCReact<AppRouter, unknown> = createTRPCReact<AppRouter>();

export function makeTrpcClient() {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: `${import.meta.env.VITE_SERVER_URL ?? ""}/trpc`,
        fetch: (url, options) => fetch(url, { ...options, credentials: "include" }),
        headers() {
          return { "x-bookclub-request": "1" };
        },
      }),
    ],
  });
}
